import { useQuery, type QueryClient } from "@tanstack/react-query";
import { getAuthUserInfo } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const USER_INFO_QUERY_KEY = "USER_INFO";

export const userInfoKeys = {
  all: [USER_INFO_QUERY_KEY] as const,
};

const userInfoQueryOptions = {
  queryKey: userInfoKeys.all,
  queryFn: () =>
    processResponseWithApiProblemDetails(() => getAuthUserInfo())(),
  staleTime: 1000 * 60 * 5, // 5 minutes - user info doesn't change frequently
} as const;

export function useUserInfoQuery(isEnabled = true) {
  return useQuery({ ...userInfoQueryOptions, enabled: isEnabled });
}

export function prefetchUserInfo(queryClient: QueryClient) {
  return queryClient.prefetchQuery(userInfoQueryOptions);
}
